import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface StatusButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

export default function StatusButton({ onClick, disabled }: StatusButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      color={'success'}
      variant="contained"
      onClick={onClick}
      disabled={disabled}
    >
      {t('general.finalization')}
    </Button>
  );
}
